<div class="pedido-itens-erro-inline" *ngIf="mensagem">
  <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
  <span>{{ mensagem }}</span>
</div>
